import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { EventService } from '../../services/event.service';
import { PixelService } from '../../services/pixel.service';

interface FooterSocial {
  text: string;
  link: string;
}
@Component({
    selector: 'app-ready',
    templateUrl: './ready.component.html',
    styleUrls: ['./ready.component.scss'],
    standalone: false,
})
export class ReadyComponent implements AfterViewInit {
    private readonly _platformId = inject(PLATFORM_ID);
    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly eventService = inject(EventService);
      private readonly pixelService = inject(PixelService);
      
    ngAfterViewInit(): void {
        // Force change detection after view init — needed for SSR hydration
        if (isPlatformBrowser(this._platformId)) {
            this.cdRef.detectChanges();
        }
    }

    enterConsole(): void {
        this.eventService.showBuyWidget('cta');
    }

  readonly social: FooterSocial[] = [
    { text: 'footer_navigation.telegram', link: 'https://t.me/seerdexofficial' },
    { text: 'footer_navigation.twitter', link: 'https://x.com/seerdexmarkets' },
    // { text: 'footer_navigation.instagram', link: 'https://www.instagram.com/predex.xyz/' },
    { text: 'footer_navigation.discord', link: 'https://discord.com/invite/ep2p9PWNk' },
  ];


  trackExternalLink(url: string, name: string): void {
    this.pixelService.trackPageClick(url, name);
  }
}
